import axios from "axios";
import Vue from "vue";
//import Cookie from 'js-cookie'
import VueSweetalert2 from "vue-sweetalert2";
import { store } from "../store/store";

Vue.use(VueSweetalert2);

//this will be the object to track the pending requests
const pendingRequests = new Set();

let Api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000,
});

Api.interceptors.request.use((config) => {
  pendingRequests.add(config.url); // Add request to the set
  return config;
});

Api.interceptors.response.use(
  function (response) {
    if (response.status == 204) {
      let text = "";

      if (response.config.method == "delete") {
        text = "Sikeres törlés";
        Vue.swal({
          toast: true,
          position: "bottom-right",
          iconColor: "green",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: "success",
          title: text,
        });
      } /*else{
				text = 'Sikeres bejelentkezés';
			}*/ //egyenlőre nem dobálja a sikeres bejelentkezést, meg kell nézni mi van a válaszba bejelentkezesnel még
    }
    if (response.status == 201) {
      Vue.swal({
        toast: true,
        position: "bottom-right",
        iconColor: "green",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        icon: "success",
        title: "Sikeres Létrehozás!",
      });
    }
    if (response.status == 202) {
      if (response.data != undefined && response.data.silent != true) {
        Vue.swal({
          toast: true,
          position: "bottom-right",
          iconColor: "green",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: "success",
          title: "A művelet sikeres volt!",
        });
      }
    }
    // Remove completed request from the set
    pendingRequests.delete(response.config.url);
    return response;
  },
  function (error) {
    // Remove failed request from the set
    pendingRequests.delete(error.config?.url);
    if (typeof error.response != "undefined") {
      if (error.response.status == 401 || error.response.status == 419) {
        document.cookie =
          "cookiename= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        localStorage.removeItem("auth");
        localStorage.removeItem("user");
        top.location.reload();
        return new Promise(() => {});
      } else if (error.response.status == 403) {
        Vue.swal({
          toast: true,
          position: "bottom-right",
          iconColor: "red",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: "error",
          title: "Nincs jogosultságod a kért művelet végrehajtásához!",
        });
        throw error;
      } else if (error.response.status == 404) {
        Vue.swal({
          toast: true,
          position: "bottom-right",
          iconColor: "red",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: "error",
          title: error.response.data.message,
        });
        throw error;
      } else if (error.response.status == 422) {
        let error_keys = Object.keys(error.response.data.errors);
        if (error_keys.length == 1) {
          Vue.swal({
            toast: true,
            position: "bottom-right",
            iconColor: "red",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "error",
            title: error.response.data.errors[error_keys[0]][0],
          });
          //return new Promise(() => { });
          throw error;
        } else {
          throw error;
        }
      } else if (error.response.status == 500) {
        Vue.swal({
          toast: true,
          position: "bottom-right",
          iconColor: "red",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: "error",
          title: "Homokszem került a gépezetbe!",
        });
        throw error;
      } else if (error.response.status == 503) {
        Vue.swal({
          toast: true,
          position: "bottom-right",
          iconColor: "red",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          icon: "error",
          title: "A szerver frissítés alatt áll, egy kis türelmet kérünk!",
        });
      }
    } else {
      if (error.code === "ECONNABORTED") {
        store.commit("updateOnline", false);
      }
      return new Promise(() => {});
    }
  }
);

// Expose function to check pending requests
export function hasPendingRequests() {
  return pendingRequests.size > 0;
}

Api.defaults.withCredentials = true;

export default Api;
